import { render, staticRenderFns } from "./MedicionAusentismoFichaPagination.vue?vue&type=template&id=b56ed070&"
import script from "./MedicionAusentismoFichaPagination.vue?vue&type=script&lang=js&"
export * from "./MedicionAusentismoFichaPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports